<template>
  <layout-animated-underline-component
    :class="$style.root"
    :to="!disabled ? routeObject : {}"
    :disabled="disabled ? '' : null"
    :inverted="true"
  >
    <template #default>
      <template v-if="slots.default">
        <slot />
      </template>
      <template v-else>
        {{ $t('shared.view') }}
      </template>
    </template>
  </layout-animated-underline-component>
</template>

<script lang="ts" setup>
const slots = useSlots()

const route = useRoute()
const props = defineProps({
  id: {
    type: Number,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const routeObject = computed(() => getParticipantIdPath(props.id, route?.params?.slug))
</script>

<style module>
.root {
  composes: reset-link font-size-small from global;
}
</style>
